import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { LanguageContext } from "../../../context/Language.contex";
import { TopPage } from "./Top";
import { Wave } from "./Wave";
import Section2 from "./Section2";
import BlogPage from "./BlogPage";
import { StatsSection } from "./CountGrafik";
import { RevealOnScroll } from "./helper";
import AboutUmkm from "./Section4";

export const Home = () => {
  const { language } = useContext(LanguageContext);

  return (
    <>
      <RevealOnScroll>
        <TopPage /> {/* Hero section biasanya langsung visible */}
      </RevealOnScroll>
      <RevealOnScroll>
        <AboutUmkm />
      </RevealOnScroll>
      <RevealOnScroll>
        <Section2 />
      </RevealOnScroll>
      <RevealOnScroll>
        <StatsSection />
      </RevealOnScroll>
      <RevealOnScroll>
        <BlogPage />
      </RevealOnScroll>
    </>
  );
};
